import { Logo } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { t } = useTranslation();
  return (
    <aside
      data-testid="login-sidebar"
      className="flex w-full flex-col gap-4 bg-gradient-to-br from-secondary-1 via-secondary-2 to-secondary-1 px-6 py-4 sm:max-w-xs"
    >
      <img src={Logo.myoshLogoWhite} alt={t(($) => $.loginSidebarAlt)} className="w-40" />
      <h1 className="font-bold text-background text-md drop-shadow-lg sm:text-lg md:text-xl dark:text-foreground">
        {t(($) => $.loginSidebarTagline)}
      </h1>
    </aside>
  );
};

export default Sidebar;
